import {
  TAutoCompleteOptions,
  TDeliveryScheduleTab,
} from '../../../utils/types';

const STATUS_OPTIONS: TAutoCompleteOptions[] = [
  {
    value: 'Ready_for_Dispatch',
    label: 'Ready For Dispatch',
  },
  {
    value: 'Scheduled',
    label: 'Scheduled',
  },
  {
    value: 'Dispatched',
    label: 'Dispatched',
  },
  {
    value: 'Delivered',
    label: 'Delivered',
  },
];

export const DELIVERY_SCHEDULE_TABS: TDeliveryScheduleTab[] =
  [
    {
      label: 'Ready For Dispatch',
      status: 'Ready_for_Dispatch',
      fragment: 'Ready_for_Dispatch',
      statusOptions: [{ ...STATUS_OPTIONS[0] }],
    },
    {
      label: 'Scheduled',
      status: 'Scheduled',
      fragment: 'Scheduled',
      statusOptions: [{ ...STATUS_OPTIONS[1] }],
    },
    {
      label: 'Dispatched',
      status: 'Dispatched',
      fragment: 'Dispatched',
      statusOptions: [{ ...STATUS_OPTIONS[2] }],
    },
    {
      label: 'Delivered',
      status: 'Delivered',
      fragment: 'Delivered',
      statusOptions: [{ ...STATUS_OPTIONS[3] }],
    },
    {
      label: 'All',
      status: '',
      countKey: 'totalCount',
      fragment: 'all',
      statusOptions: [...STATUS_OPTIONS],
    },
  ];

export const emptyOptionList: TAutoCompleteOptions[] = [
  {
    value: 'EMPTY',
    label: 'Empty',
  },
];

export const TRANSPORTER_TYPES: TAutoCompleteOptions[] = [
  {
    value: 'PTL',
    label: 'PTL',
  },
  {
    value: 'FTL',
    label: 'FTL',
  },
  {
    value: 'Adhoc',
    label: 'Adhoc',
  },
  {
    value: 'Self Pickup',
    label: 'Self Pickup',
  },
];
